import { ColumnDef } from '@tanstack/react-table';
import {
  formatTableDate,
  formatTableTimestamp,
} from '../../utils/formatTableDate';
import {
  SortableHeader,
  TruncatedCell,
  DownloadedCheckmark,
} from '@/components';
import { ImagingRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';
import { DASH } from '../../utils/displayValues';

export const createImagingColumns = (): ColumnDef<ImagingRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) =>
      row.original.name === null ? (
        DASH
      ) : row.original.name ? (
        <TruncatedCell text={row.original.name} />
      ) : (
        'No data available'
      ),
  },
  {
    accessorKey: 'imagingTypeName',
    header: 'Imaging Type',
    cell: ({ row }) =>
      row.original.imagingTypeName === null
        ? DASH
        : row.original.imagingTypeName || 'No data available',
  },
  {
    accessorKey: 'bodyPartName',
    header: 'Body Part',
    cell: ({ row }) =>
      row.original.bodyPartName === null
        ? DASH
        : row.original.bodyPartName || 'No data available',
  },
  {
    id: 'dateOfStudy',
    accessorKey: 'dateOfStudy',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date of Study</SortableHeader>
    ),
    cell: ({ row }) => formatTableDate(row.original.dateOfStudy),
  },
  {
    id: 'dateUploaded',
    accessorFn: (row) => row.createdAt,
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date Uploaded</SortableHeader>
    ),
    cell: ({ row }) => formatTableTimestamp(row.original.createdAt),
  },
  {
    accessorKey: 'sourceType',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Source Type</SortableHeader>
    ),
    cell: ({ row }) => row.original.sourceType || 'No data available',
  },
  {
    id: 'markedDownloaded',
    enableSorting: false,
    header: '',
    cell: ({ row }) =>
      row.original.markedDownloaded ? <DownloadedCheckmark /> : null,
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => (
      <div className="flex items-center justify-end gap-1">
        <PatientDocumentViewButton
          disabled={!row.original.sourceType}
          documentKey={{
            source: DocumentSource.MEDICAL_RECORDS,
            type: DocumentType.IMAGING,
            imagingId: row.original.id,
            sourceType: row.original.sourceType,
            name: row.original.name === null ? DASH : row.original.name,
          }}
        />
      </div>
    ),
  },
];
